module.exports = __webpack_public_path__ + "static/media/4.1540acea.jpg";